import './style.scss';
import React, { useState, useRef, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import SVG from 'react-inlinesvg';

import { connect } from 'react-redux';
import { updatePreTest } from 'actions';

import useCards from 'pctHooks/useCards';
import useSrcSetVerify from 'pctHooks/useSrcSetVerify';

import { removeTagsHtml } from "services/utils";

import {
    Label,
    Text,
    Image,
    ProgressBar,
    Duration,
    Visualization,
    Mandatory,
    Sequential,
    Registered,
    ButtonCertificate,
    Like,
    ViewSyllabus,
} from '../../atoms';
import ShareButton from 'pctComponents/organisms/ShareButton';
import { getProfileInfo } from 'services/utils';
import NiceModal, { useModal } from '@ebay/nice-modal-react';
import ModalEquivalencyPages from 'pctComponents/modals/ModalEquivalencyPages';
import { getEquivalences } from 'services/api';
import { Button } from 'react-bootstrap';
import zIndex from '@material-ui/core/styles/zIndex';
import BadgeNewContent from 'pctComponents/BadgeNewContent';

type idType = {
    id?: string;
};

type Props = {
    className?: string;
    css?: object;
    collection: BlockElement | any;
    dataParent?: any;
    format: string;
    effects: string;
    configPreTest?: {
        statusPreTest: Boolean | null;
    };
};

const CardStandard = (props: Props) => {
    const { collection, className = '', dataParent, css = {}, format = 'portrait', effects = '' } = props;

    const { id } = useParams<idType>();

    const setProgressStateRef = useRef(null as any);
    const progressInfoRef = useRef(null as any);
    const user = getProfileInfo();
    //
    const {
        image,
        concluidedText,
        verifyCompletedStatus,
        currentLabel,
        isEnrollment,
        initialProgressState,
        statusRegistered,
        classNotStartedYet,
        prerequisitesMet,
        handleCardMouseEvent,
        handleCertificateMouseEvent,
        hasCertificate,
        currentBreadText,
        statusElement,
        hasEnrollment,
        nodeAvailable,
        preRequisiteBlockMet,
    } = useCards({
        collection,
        id,
        dataParent,
        setProgressStateRef,
        progressInfoRef,
    });

    const configPreTest = props.configPreTest?.statusPreTest || false;

    const [progressInfo, setProgressState] = useState(initialProgressState());
    const [equivalencePages, setEquivalencePages] = useState([]);
    // const [loadingEquivalencies, setLoadingEquivalencies] = useState(false);
    const { equivalentNodeCode } = collection?.data?.nodeEnrollment || {};
    const hasEquivalence = Boolean(equivalentNodeCode);

    useEffect(() => {
        (async () => {
            if (!hasEquivalence) {
                return;
            }

            // setLoadingEquivalencies(true);
            try {
                const {
                    data: { result },
                } = await getEquivalences(collection?.data?.idNode || 0);
                setEquivalencePages(result.map((page) => ({ title: page.origin.title })));
                // setLoadingEquivalencies(false);
            } catch (error) {
                // setLoadingEquivalencies(false);
            }
        })();
    }, [collection, equivalentNodeCode, user.idUser, hasEquivalence]);

    setProgressStateRef.current = setProgressState;
    progressInfoRef.current = progressInfo;

    const stsEnrollment = hasEnrollment() && collection.data?.nodeType !== 'ORGANIZATION';
    const showNewBadge = collection?.newlyAvailable;
    const textBadge = collection?.newContentInternal ? 'Novo' : 'Novos conteúdos';
    

    const imgBase = (statusElement() === 'ARCHIVED' || !nodeAvailable()) && image().image ? image().image : image();
    const srcSetVerify = useSrcSetVerify(imgBase, format);
    // console.log('srcSetVerify', srcSetVerify);

    const youtubeRegex = /^(https?:\/\/)?(www\.)?(youtube\.com|youtu\.be)\/.+/;

    const isYouTubeLink = (link) => {
        return youtubeRegex.test(link);
    };

    const showEquivalenceModal = () => {
        NiceModal.show(ModalEquivalencyPages, {
            obj: {
                pages: equivalencePages,
            },
        });
    };

    const handleCard = (e: React.MouseEvent<HTMLElement>) => {
        if (configPreTest || !!isEnrollment().processing) {
            e.stopPropagation();
            return;
        }

        handleCardMouseEvent(e);
    };

    const handleEquivalence = (e: React.MouseEvent<HTMLElement>) => {
        if (configPreTest) {
            e.stopPropagation();
            return;
        }

        if (hasEquivalence) {
            showEquivalenceModal();
        }

        e.stopPropagation();
    };

    const handleCertificate = (e: React.MouseEvent<HTMLElement>) => {
        if (configPreTest || !!isEnrollment().processing) {
            e.stopPropagation();
            return;
        }

        handleCertificateMouseEvent(e);
    };

    const syllabusStatus =
        collection.data.syllabus &&
        removeTagsHtml(collection.data.syllabus).length > 0 &&
        collection.data.nodeType === 'LEARNING';

    return (
        <div
            className={`pctMolecule pctCard pctCardStandard ${
                preRequisiteBlockMet === true ||
                prerequisitesMet() === false ||
                statusRegistered() === 'inactive' ||
                statusElement() === 'ARCHIVED' ||
                classNotStartedYet()
                    ? 'pctCardLock'
                    : ''
            } `}
            style={css}
            onClick={handleCard}
        >
            <Registered status={statusRegistered()} statusElement={statusElement()} />

            {/* {(star || award ) && <div className='gamifyData'>
                { <Star text={star} />}
                { <Award text={award} />}
            </div>} */}

            {collection.data.parentType !== 'CATALOG' && statusElement() !== 'ARCHIVED' && (
                <div className="containerMandatoryLock containerMandatoryLock2">
                    {isYouTubeLink(collection.data.contentLocation) && Boolean(collection.data.shareable) ? (
                        <ShareButton
                            className="ShareButtonCardStandard"
                            callEvent={(e) => (isEnrollment().processing ? () => {} : e.stopPropagation())}
                            link={collection.data.contentLocation}
                            idContent={collection.idElement}
                            idUser={user.idUser}
                        />
                    ) : (
                        ''
                    )}
                    <Mandatory status={collection.data.mandatory} className="mandatoryCardStandard" />
                    <Sequential
                        status={
                            !isEnrollment().processing &&
                            prerequisitesMet() &&
                            !preRequisiteBlockMet &&
                            statusRegistered() !== 'inactive' &&
                            !classNotStartedYet()
                        }
                    />
                </div>
            )}

            <div
                className="containerData"
                data-aspectratio={format}
                style={{
                    opacity: isEnrollment().processing ? 0.2 : 1,
                    cursor: isEnrollment().processing ? 'not-allowed' : 'pointer',
                }}
            >
                {showNewBadge && <BadgeNewContent text={textBadge} />}
                <Like
                    css={{
                        cursor: isEnrollment().processing ? 'not-allowed' : 'pointer',
                    }}
                    direction="invert"
                    collection={collection}
                    statusRegistered={statusRegistered()}
                    disabled={!!isEnrollment().processing || !!configPreTest}
                />

                {/* Card com Imagem cadastrada e padrão */}
                {collection.data.image && collection.elementType !== 'EVALUATION' && statusElement() !== 'ARCHIVED' && (
                    <>
                        <Image
                            path={srcSetVerify || image()}
                            placeholder={true}
                            pathSet={srcSetVerify}
                            cardEffect={effects === 'shadow'}
                        />
                    </>
                )}

                {/* Card sem Imagem cadastrada e padrão */}
                {!collection.data.image &&
                    collection.elementType !== 'EVALUATION' &&
                    statusElement() !== 'ARCHIVED' && <div className="thumb">{<SVG src={imgBase} />}</div>}

                {/* Verificacao do tipo EVALUATION com imagem */}
                {collection.elementType === 'EVALUATION' &&
                    (collection.data.image ? (
                        <Image path={srcSetVerify || image()} placeholder={true} />
                    ) : (
                        <>
                            <div className="thumb">{image() && <SVG src={image()} />}</div>
                        </>
                    ))}

                {/* ATENÇÃO: Páginas Arquivadas nem aparece mais para o usuário */}
                {statusElement() === 'ARCHIVED' && (
                    <div className="thumb">
                        {
                            <>
                                {image().svg && <SVG src={image().svg} />}

                                {!collection.data.image && (
                                    <div className="thumb">{image() && <SVG src={image().image} />}</div>
                                )}

                                {collection.data.image && (
                                    <Image
                                        path={image().image}
                                        placeholder={true}
                                        pathSet={srcSetVerify}
                                        cardEffect={effects === 'shadow'}
                                    />
                                )}
                            </>
                        }
                    </div>
                )}
                {/* ATENÇÃO: Páginas Arquivadas nem aparece mais para o usuário */}

                <div className={`progressConclusionConteiner`}>
                
                    {stsEnrollment && (
                        <ProgressBar collection={collection} percentage={progressInfo} status={statusElement()} />
                    )}

                    {statusElement() !== 'ARCHIVED' && (
                        <div className="conclusionConteiner">
                            {stsEnrollment && (
                                <Button className={hasEquivalence ? 'clickable-label' : ''} onClick={handleEquivalence}>
                                    <Text component="small" className="dis" text={concluidedText()} />
                                </Button>
                            )}

                            {hasCertificate() && (
                                <ButtonCertificate
                                    verifyCompletedStatus={verifyCompletedStatus()}
                                    onClick={handleCertificate}
                                />
                            )}
                        </div>
                    )}
                </div>
            </div>

            {/* {collection.data.mandatory == 1 && (
        <Text component="small" className="dis " text={concluidedText()} />
      )} */}

            {<Text text={currentBreadText()} component={'small'} className="breadCard" />}
            <Text
                component="p"
                text={collection.data?.title}
                title={true}
                className="titleCard"
                css={{
                    opacity: isEnrollment().processing ? 0.2 : 1,
                }}
            />

            <div
                className="labelData"
                style={{
                    opacity: isEnrollment().processing ? 0.2 : 1,
                }}
            >
                <div className="labelDataItem leftInfo">
                    <Label text={currentLabel()} className="label" />
                    <div className="blockDataItens">
                        <div className="bDataItem">
                            <Duration text={collection.data?.workload} className="RightInfo" timeFormat={'seconds'} />
                        </div>
                        {syllabusStatus ? <div className="bDataItem">
                            <ViewSyllabus collection={collection} />
                        </div> : null}
                    </div>
                </div>

                {/* <Trophy idElement={collection.idElement} /> */}

                {collection.data.views > 0 && <Visualization text={collection.data.views} />}
            </div>
        </div>
    );
};

const mapStateToProps = (store) => ({
    configPreTest: store.configPreTestState,
});

const mapDispatchToProps = (dispatch) => ({
    updatePreTest: (item) => dispatch(updatePreTest(item)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CardStandard);
